import PageGroupsList from './PageGroupsList';
import PageGroupsItem from './PageGroupsItem';

export {
  PageGroupsList,
  PageGroupsItem,
};



// WEBPACK FOOTER //
// ./src/components/PageGroups/index.js